<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-9 col-12 mb-2">
                <div class="row breadcrumbs-top">
                    <div class="col-12">
                        <h2 class="content-header-title float-left mb-0">Suggestions</h2>
                    </div>
                </div>
            </div>
        </div>
        <div class="content-body">
            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-header">
                            Filtre
                        </div>
                        <div class="card-body">
                            <div class="form-group row">
                                <div class="col-sm-3" v-if="step == '1'">
                                    <select @change="getWithProduct" v-model="product" class="form-control">
                                        <option value="">Tous les produits</option>
                                        <option value="1">Aussurance Auto</option>
                                        <option value="3">Assurance Voyage</option>
                                        <option value="2">Assurance Habitation</option>
                                    </select>
                                </div>
                                <div class="col-sm-3" v-else>
                                    <select @change="getWithProductArchived" v-model="archived" class="form-control">
                                        <option value="">Tous les produits</option>
                                        <option value="1">Assurance Auto</option>
                                        <option value="3">Assurance Voyage</option>
                                        <option value="2">Assurance Habitation</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <section id="basic-tabs-components">
                <div class="row match-height">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-body">
                                <ul class="nav nav-tabs" role="tablist">
                                    <li class="nav-item" @click="step = '1'">
                                        <a class="nav-link active" id="home-tab" data-toggle="tab" href="#home" aria-controls="home" role="tab" aria-selected="true">Toutes</a>
                                    </li>
                                    <li class="nav-item" @click="step = '2'">
                                        <a class="nav-link" id="profile-tab" data-toggle="tab" href="#profile" aria-controls="profile" role="tab" aria-selected="false">Archivées</a>
                                    </li>
                                </ul>
                                <div class="tab-content">
                                    <div class="tab-pane active" id="home" aria-labelledby="home-tab" role="tabpanel">
                                        <all-suggestions ref="allSuggestions"/>
                                    </div>
                                    <div class="tab-pane" id="profile" aria-labelledby="profile-tab" role="tabpanel">
                                        <archived-suggestions ref="archivedSuggestions"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import allSuggestions from './item/all.vue'
import archivedSuggestions from './item/archived.vue'
export default {
    components:{
        allSuggestions,
        archivedSuggestions
    },
    data: () => ({
        product: '',
        archived: '',
        step : 1
    }),
    methods:{
        getWithProduct(){
            this.$refs.allSuggestions.getWithProduct(this.product)
        },
        getWithProductArchived(){
            this.$refs.archivedSuggestions.getWithProduct(this.archived)
        }
    }
}
</script>
